"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgPumpAlphaFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M10 2v2h2v2.84c.33-.14.66-.27 1-.38s.66-.19 1-.26a10.1 10.1 0 014 0c.34.07.67.16 1 .26s.67.24 1 .38V4h2V2zM19 25.54c-.33.1-.66.19-1 .26a10.1 10.1 0 01-4 0c-.34-.07-.67-.16-1-.26s-.67-.24-1-.38V28h-2v2h12v-2h-2v-2.84c-.33.14-.66.27-1 .38z" }),
        React.createElement("circle", { cx: 16, cy: 16, r: 8 })));
}
exports.default = SvgPumpAlphaFilled;
//# sourceMappingURL=PumpAlphaFilled.js.map